<template>
  <div>
    <GeneralTreeFolder />
    <div class="flex items-center justify-between">
      <slot name="interactive-button-section"></slot>
    </div>
  </div>
</template>

<script>
// import { mapState } from 'vuex'
import GeneralTreeFolder from '@/components-v2/common/move-presentation/GeneralTreeFolder.vue'
import moveFolderMixin from '@/mixins/folder/move-folderMixin'

export default {
  name: 'TabMyPresentations',
  components: {
    GeneralTreeFolder,
  },
  mixins: [moveFolderMixin],
  mounted() {
    this.getAndSetMyPresentationFolders()
  },
}
</script>
